import React from 'react';
import classnames from 'classnames';
import {Button} from '@br/br-components';

import FBLoginButton from '../atoms/fbLoginButton';
import BrLogo from '../atoms/brLogo';

class ChooseLoginMethod extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onPhone = this.props.stepCompleted.bind(this, 'phone');
    this.onEmail = this.props.stepCompleted.bind(this, 'email');
    this.onFacebook = this.onFacebook.bind(this);
  }

  onFacebook(...args) {
    return this.props
      .onFbOauth(...args)
      .then(async () => {
        await this.props.mParticleLogin(
          {
            email: this.props.email || '',
          },
          {
            loggedIn: true,
            signup_source: 'facebook',
            account_verified: true,
          }
        );
        this.props.stepCompleted(true);
        this.props.trackEvent({
          tag_manager_event: 'login',
          accountType: 'facebook',
          screen: this.props.screen || 'Login',
          loginSuccess: true,
        });
      })
      .catch((err) => {
        this.setState({errors: [err]});
        this.props.trackEvent({
          tag_manager_event: 'login',
          accountType: 'facebook',
          screen: this.props.screen || 'Login',
          loginSuccess: false,
        });
        this.props.trackEvent({
          tag_manager_event: 'user_error',
          errorType: 'account_management',
          errorMessage: err.output.payload.error || err.message,
          errorCode: err.data.errorCode,
          page: 'facebook',
        });
      });
  }

  render() {
    const classes = classnames({
      chooseLoginMethod: true,
      molecule: true,
    });
    return (
      <div className={classes}>
        <BrLogo />
        <Button classes="phone" onClick={this.onPhone}>
          Sign in with Phone
        </Button>
        <FBLoginButton attemptFbLogin={this.onFacebook} loadScript={this.props.addScript}>
          Sign in with Facebook
        </FBLoginButton>
        <Button classes="email" onClick={this.onEmail}>
          Sign in with Email
        </Button>
        <Button classes="signUp" href="/sign_up">
          Don’t have an account? Sign Up
        </Button>
      </div>
    );
  }
}

export default ChooseLoginMethod;
